'use client';

import { useRouter, usePathname } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import i18nConfig, { supportedLngs } from '@/i18nConfig';
import { MenuItem, SelectChangeEvent } from '@mui/material';
import SelectComponent from './shared/SelectComponent';

export default function LanguageChanger() {
  const { i18n, t } = useTranslation();
  const currentLocale = i18n.language;
  const router = useRouter();
  const currentPathname = usePathname();

  const selectOptions = Object.entries(supportedLngs).map(([code, name]) => (
    <MenuItem value={code} key={code}>
      {name}
    </MenuItem>
  ));

  const handleChange = (e: SelectChangeEvent<any>) => {
    const newLocale = e.target.value;

    // set cookie for next-i18n-router
    const days = 30;
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = date.toUTCString();
    document.cookie = `NEXT_LOCALE=${newLocale};expires=${expires};path=/`;

    // redirect to the new locale path
    if (currentLocale === i18nConfig.defaultLocale && !i18nConfig.prefixDefault) {
      router.push('/' + newLocale + currentPathname);
    } else {
      router.push(currentPathname.replace(`/${currentLocale}`, `/${newLocale}`));
    }

    router.refresh();
  };

  return (
    <SelectComponent
      variant='filled'
      selectOptions={selectOptions}
      selectedValue={i18n.resolvedLanguage as string}
      handleChange={handleChange}
      selectLabel={t('language-switcher-select-label')}
      formControlSx={{ minWidth: 0 }}
      labelId='language-switcher-select-label-id'
      selectId='language-switcher-select-id'
    />
  );
}
